// src/data/crisisSupport.js
// Crisis support numbers by country for Inner Voice Vibe (the Resources
// page). The app serves seven markets: Australia, New Zealand, India, the UK,
// Ireland, Canada and the US.
//
// ⚠️ The numbers are not kept here. They live in the fleet's one table,
// packages/crisis-support/src/services.js, with the date each was verified
// and the page it was verified on. Change a number or its hours THERE, never
// by overriding it here. This app shows the 'young' list, as the other Vibe
// apps do.
//
// Until 30 September 2026 the Resources page held its own copy of five
// countries (no India or Ireland), with Talk Suicide Canada's retired number,
// Lifeline Aotearoa as 24/7 and an emergency box that told New Zealand to
// call 000.
//
// Imported by relative path, not a Vite alias, so the file also loads in
// plain Node (tests, and the Knowledge Hub importer).

import {
  crisisSupportTable,
  countryPreference,
  serviceById,
  normaliseCountryKey,
  emergencyCallAdvice,
  COUNTRY_KEYS,
  DEFAULT_COUNTRY
} from '../../../../packages/crisis-support/src/index.js';

export const CRISIS_SUPPORT = crisisSupportTable('young');

export { COUNTRY_KEYS, DEFAULT_COUNTRY, normaliseCountryKey, emergencyCallAdvice, serviceById };

// Where the reader's country choice lives, shared by every surface that shows
// numbers (the coach's crisis footer, and any page that offers a picker).
export const COUNTRY_PREF_KEY = 'inner-voice-vibe_crisis_country';

export const { readCountryPref, writeCountryPref, initialCountry } = countryPreference(COUNTRY_PREF_KEY);

/**
 * Look up crisis support for a region. Fails CLOSED: an unknown or missing
 * region returns null, never another country's line.
 */
export const getCrisisSupport = (key) => CRISIS_SUPPORT[normaliseCountryKey(key)] || null;

// The Resources page's own view: headspace added in Australia (it had
// eheadspace), and the shared youthFocused flag shown as its "Teen
// Specialist" badge (teenSpecific).
const EXTRAS = { australia: ['au-headspace'] };

export const RESOURCES_BY_COUNTRY = Object.fromEntries(
  Object.entries(CRISIS_SUPPORT).map(([key, country]) => [key, {
    ...country,
    services: [...country.services, ...(EXTRAS[key] || []).map(serviceById)]
      .map((service) => ({ ...service, teenSpecific: Boolean(service.youthFocused) }))
  }])
);
